import './contact_us.less'
import { Logo2 } from '../../components/SvgIcons'

export default function ContactUsWidget() {
  return (
    <>
      <div class="support-stacked-container">
        <div style={{ marginTop: -30, textAlign: 'center', height: 150 }}>
          <img src={Logo2} style={{ width: 200 }}></img>
        </div>
        {/* <!-- การ์ดบน: ระบบทั่วไป --> */}
        <div class="support-card highlighted">
          <div class="card-header">
            <span class="icon">💻</span>
            <h3>กรณีพบปัญหาการใช้งานระบบทั่วไป โปรดติดต่อทีมสนับสนุนที่ Appscenter สสส.</h3>
          </div>
          <div class="card-body ">
            {/* <p class="team-name">โปรดติดต่อทีมสนับสนุนที่ Appscenter สสส.</p> */}
            <div class="info-grid">
              <div class="info-item">
                <span class="label">⏰ เวลาทำการ</span>
                <span class="value">
                  วันจันทร์ - อาทิตย์ | 08.30 - 17.00 น.{' '}
                  <span style={{ color: '#ed7e24' }}>(ยกเว้น วันหยุดราชการ)</span>
                </span>
              </div>
              <div class="info-item">
                <span class="label">📞 เบอร์โทรศัพท์</span>
                <span class="value">
                  <a href="tel:023431500">02-343-1500</a> กด <a>4</a>
                </span>
              </div>
              <div class="info-item">
                <span class="label">✉️ อีเมล</span>
                <span class="value">
                  <a href="mailto:appscenter@thaihealth.or.th">appscenter@thaihealth.or.th</a>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- การ์ดล่าง: ด้านการเงิน/บัญชี --> */}
        <div class="support-card highlighted">
          <div class="card-header">
            <span class="icon">💰</span>
            <h3>
              กรณีต้องการติดต่อช่องทางให้คำปรึกษา ด้านการเงิน บัญชี ภาษี และพัสดุ <br />
              และส่วนงาน New e-Fin
            </h3>
          </div>
          <div class="card-body">
            <div class="info-grid">
              <div class="info-item">
                <span class="label">⏰ เวลาทำการ</span>
                <span class="value">
                  วันจันทร์ - ศุกร์ | 09.00 - 17.00 น.{' '}
                  <span style={{ color: '#ed7e24' }}>(ยกเว้น วันหยุดราชการ)</span>
                </span>
              </div>
              <div class="info-item">
                <span class="label">📞 เบอร์โทรศัพท์</span>
                <span class="value">
                  <a href="tel:023431500">02-343-1500</a> กด <a>3</a>
                </span>
              </div>
              <div class="info-item">
                <span class="label">📱 เบอร์มือถือ</span>
                <span class="value">
                  <a href="tel:0970980919">097-098-0919</a>
                </span>
              </div>
              <div class="info-item">
                <span class="label">✉️ อีเมล</span>
                <span class="value">
                  <a href="mailto:fincenter@thaihealth.or.th">fincenter@thaihealth.or.th</a>
                </span>
              </div>
              <div class="info-item">
                <span class="label label-line">
                  <span class="line-icon-bg">💬</span> LINE Official
                </span>
                <span class="value">
                  <strong class="line-tag">@support.sss</strong>{' '}
                  <small>(เพิ่มเพื่อนผ่าน LINE ID)</small>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
